// 腾讯会议超管ID
export const MEETING_ADMIN_ID = 'meeting336177'
